<template>
    <h3 class="section-title">
        <!-- <i class="icon-bracket"></i> -->
        <slot></slot>
    </h3>
</template>

<script>
export default {

}
</script>

<style lang="scss">
h3.section-title {
    text-align: center;
    position: relative;
    margin-top: 3rem;
    margin-bottom: 3rem;
    font-family: $font-family-poppins-first;
    text-transform: uppercase;

    $width: 60px;
    &:after {
        content: '';
        width: $width;
        height: 2px;
        background: var(--primary);
        position: absolute;
        left: 50%;
        margin-left: $width / 2 * -1;
        bottom: -20px;
    }

    em,i {
        vertical-align: baseline;
        font-size: 80%;
        font-style: normal;
        opacity: .4;
    }

    em {
        font-weight: 400;
        font-family: var(--font-family-monospace);
    }

    i {
        font-size: 2rem;
    }
}
</style>
